import React from "react";
import './Datenschutz.css';

const Datenschutz = () => {
    return (
        <div className="datenschutz-section">
            <div className="datenschutz-header">
                <span className="label-sub">Rechtliches</span>
                <h1>Datenschutzerklärung</h1>
            </div>

            <div className="datenschutz-body">
                <p>
                    Wir freuen uns über Ihr Interesse an Afrika-Link e.V. Der Schutz Ihrer personenbezogenen
                    Daten ist uns wichtig. Nachfolgend informieren wir Sie gemäß Art. 13 und 14
                    Datenschutz-Grundverordnung (DSGVO) über die Verarbeitung personenbezogener Daten bei der
                    Nutzung dieser Website.
                </p>

                <h2>1. Verantwortlicher</h2>
                <p>Verantwortlich im Sinne der DSGVO ist:</p>
                <address>
                    Afrika-Link e.V.<br />
                    Geschäftsstelle Helmstedt<br />
                    Collegienstraße 3a<br />
                    38350 Helmstedt<br />
                    Deutschland<br />
                    Telefon: +49 160 90800222<br />
                    E-Mail: <a className="datenschutz-link" href="mailto:info@afrika-link.org">info@afrika-link.org</a>
                </address>

                <h2>2. Ihre Rechte als betroffene Person</h2>
                <p>Ihnen stehen gegenüber uns hinsichtlich der Sie betreffenden personenbezogenen Daten folgende Rechte zu:</p>
                <ul>
                    <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                    <li>Recht auf Berichtigung unrichtiger oder Vervollständigung Ihrer Daten (Art. 16 DSGVO)</li>
                    <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                    <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                    <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                    <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                    <li>Recht auf Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
                </ul>
                <p>
                    Sie haben außerdem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die
                    Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Zuständig ist die
                    Aufsichtsbehörde des Bundeslandes, in dem Sie Ihren Wohnsitz haben, oder die für uns
                    zuständige Aufsichtsbehörde.
                </p>

                <h2>3. Erhebung und Speicherung personenbezogener Daten beim Website-Besuch</h2>
                <p>
                    Beim Aufrufen unserer Website werden durch den Browser, den Sie auf Ihrem Endgerät
                    verwenden, automatisch Informationen an den Server unserer Website gesendet und
                    vorübergehend in einem sogenannten Server-Log-File gespeichert. Dies sind:
                </p>
                <ul>
                    <li>IP-Adresse des anfragenden Geräts (in der Regel gekürzt/anonymisiert)</li>
                    <li>Datum und Uhrzeit des Zugriffs</li>
                    <li>Name und URL der abgerufenen Datei</li>
                    <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                    <li>verwendeter Browser und ggf. das Betriebssystem Ihres Geräts sowie der Name Ihres Access-Providers</li>
                </ul>
                <p>
                    Diese Daten werden ausschließlich zur Gewährleistung eines störungsfreien Betriebs der
                    Website sowie zur Verbesserung unseres Angebots verarbeitet (Art. 6 Abs. 1 lit. f DSGVO,
                    berechtigtes Interesse). Eine Zusammenführung dieser Daten mit anderen Datenquellen findet
                    nicht statt.
                </p>
                <p>
                    Unsere Website wird bei einem externen Hosting-Anbieter (Amazon Web Services, betrieben
                    über Amazon Web Services EMEA SARL sowie ggf. verbundene Unternehmen in den USA)
                    gehostet. Der Hosting-Anbieter verarbeitet die oben genannten Server-Log-Daten in unserem
                    Auftrag auf Grundlage eines Auftragsverarbeitungsvertrags gemäß Art. 28 DSGVO. Soweit dabei
                    Daten in die USA übermittelt werden, stützen wir uns auf die EU-Standardvertragsklauseln
                    bzw. ein anderweitig anerkanntes Datenschutzniveau.
                </p>

                <h2>4. Cookies, lokale Speicherung und Ihre Einwilligung</h2>
                <p>
                    Unsere Website verwendet keine Cookies, die für den technischen Betrieb der Seite nicht
                    zwingend erforderlich wären, mit Ausnahme des unter Punkt 5 beschriebenen Firebase
                    Analytics. Beim ersten Besuch unserer Website informieren wir Sie über einen
                    Einwilligungs-Banner über den Einsatz von Firebase Analytics und bitten Sie um Ihre
                    Entscheidung. Firebase Analytics wird ausschließlich dann aktiviert, wenn Sie im Banner
                    aktiv „Alle akzeptieren" auswählen; entscheiden Sie sich für „Nur notwendige", findet
                    keine Übermittlung von Nutzungsdaten an Google statt.
                </p>
                <p>
                    Ihre Entscheidung wird in Ihrem Browser (Local Storage) gespeichert, damit Sie nicht bei
                    jedem Besuch erneut gefragt werden. Sie können Ihre Auswahl jederzeit mit Wirkung für die
                    Zukunft über den Link „Cookie-Einstellungen" im Footer unserer Website ändern oder
                    widerrufen. Zusätzlich können Sie die Speicherung von Cookies bzw. lokalen Daten durch
                    entsprechende Einstellungen Ihres Browsers verhindern; dies kann jedoch die
                    Funktionalität der Website einschränken.
                </p>

                <h2>5. Google Firebase</h2>
                <p>
                    Für den Betrieb dieser Website nutzen wir Dienste von Firebase, einem Angebot der Google
                    Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland ("Google"). Im Einzelnen
                    setzen wir folgende Firebase-Dienste ein:
                </p>
                <ul>
                    <li>
                        <strong>Cloud Firestore &amp; Firebase Storage:</strong> Zur Speicherung und Bereitstellung
                        von Inhalten wie Projektberichten, Teamfotos und weiteren Medieninhalten, die auf
                        dieser Website angezeigt werden.
                    </li>
                    <li>
                        <strong>Firebase Authentication:</strong> Für den internen, passwortgeschützten
                        Anmeldebereich unseres Teams zur Pflege der Website-Inhalte. Dieser Bereich ist nicht
                        für die Öffentlichkeit zugänglich; es werden ausschließlich Zugangsdaten
                        (E-Mail-Adresse) autorisierter Vereinsmitglieder verarbeitet.
                    </li>
                    <li>
                        <strong>Firebase Analytics (Google Analytics für Firebase):</strong> Zur statistischen
                        Auswertung der Websitenutzung, sofern Sie hierzu über unseren Einwilligungs-Banner
                        Ihre Einwilligung erteilt haben. Dabei werden Informationen wie besuchte Seiten,
                        ungefähre Verweildauer, verwendetes Gerät und Browsertyp sowie eine gekürzte
                        IP-Adresse erfasst und an Google-Server, auch in den USA, übertragen.
                    </li>
                </ul>
                <p>
                    Cloud Firestore und Firebase Storage sind für die Darstellung unserer Website-Inhalte
                    technisch erforderlich und werden auf Grundlage unseres berechtigten Interesses an einer
                    funktionsfähigen Website verarbeitet (Art. 6 Abs. 1 lit. f DSGVO). Firebase Analytics wird
                    dagegen ausschließlich auf Grundlage Ihrer aktiven Einwilligung eingesetzt (Art. 6 Abs. 1
                    lit. a DSGVO, § 25 TTDSG) und erst geladen, nachdem Sie im Einwilligungs-Banner „Alle
                    akzeptieren" ausgewählt haben. Diese Einwilligung können Sie jederzeit mit Wirkung für die
                    Zukunft über den Link „Cookie-Einstellungen" im Footer widerrufen.
                </p>
                <p>
                    Wir haben mit Google einen Auftragsverarbeitungsvertrag abgeschlossen und stützen die
                    Datenübermittlung in die USA auf die EU-Standardvertragsklauseln. Weitere Informationen zum
                    Umgang mit Nutzerdaten durch Google Firebase finden Sie in der Datenschutzerklärung von
                    Google: <a className="datenschutz-link" href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer">firebase.google.com/support/privacy</a>.
                </p>

                <h2>6. Kontaktaufnahme</h2>
                <p>
                    Wenn Sie per E-Mail oder Telefon mit uns Kontakt aufnehmen, werden die von Ihnen
                    mitgeteilten Daten (z. B. Name, E-Mail-Adresse, Telefonnummer, Inhalt Ihrer Anfrage) von
                    uns ausschließlich zur Bearbeitung Ihres Anliegens und für den Fall von Anschlussfragen
                    gespeichert und verarbeitet. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b bzw. lit. f
                    DSGVO. Eine Weitergabe dieser Daten an Dritte erfolgt nicht ohne Ihre Einwilligung.
                </p>

                <h2>7. Downloads und externe Links</h2>
                <p>
                    Auf unserer Website stellen wir Dokumente (z. B. Broschüren, Satzung, Freistellungsbescheid)
                    als Download zur Verfügung. Der Abruf dieser Dateien erfolgt technisch wie der Aufruf jeder
                    anderen Seite unserer Website (siehe Punkt 3) und erfordert keine gesonderte Eingabe
                    personenbezogener Daten. Zudem verlinken wir an einzelnen Stellen auf externe Websites
                    Dritter (z. B. unseren Partner Agri-Connect Tanzania). Für die Inhalte und den Datenschutz
                    dieser verlinkten, externen Seiten sind ausschließlich deren jeweilige Betreiber
                    verantwortlich.
                </p>

                <h2>8. SSL-/TLS-Verschlüsselung</h2>
                <p>
                    Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
                    Inhalte eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran,
                    dass die Adresszeile Ihres Browsers von „http://" auf „https://" wechselt und an dem
                    Schloss-Symbol in Ihrer Browserzeile.
                </p>

                <h2>9. Änderung dieser Datenschutzerklärung</h2>
                <p>
                    Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
                    rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der
                    Datenschutzerklärung umzusetzen. Für Ihren erneuten Besuch gilt dann die neue
                    Datenschutzerklärung.
                </p>
                <p>Stand: September 2026</p>
            </div>
        </div>
    );
};

export default Datenschutz;
